import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from "./pages-routing.module";
import { StaticMainComponent } from './static/static-main/static-main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { StaticHeaderComponent } from './static/static-header/static-header.component';
import { StaticFooterComponent } from './static/static-footer/static-footer.component';
import { IndexComponent } from './static/index/index.component';
import { ContactComponent } from './static/contact/contact.component';
import { AboutComponent } from './static/about/about.component';
import { DiscipleshipComponent } from './static/discipleship/discipleship.component';
import { GetInvolvedComponent } from './static/get-involved/get-involved.component';
import { GiveComponent } from './static/give/give.component';
import { SermonsComponent } from './static/sermons/sermons.component';
import { EventComponent } from './static/event/event.component';
import { ViewYoutubeComponent } from './static/view-youtube/view-youtube.component';
import { DiscipleshipTumiComponent } from './static/discipleship-tumi/discipleship-tumi.component';
import { KingsoopersComponent } from './static/kingsoopers/kingsoopers.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { SafePipe } from '../helper/senitize-pipe';
import { AdminService } from './admin/admin.service';
import { ItimComponent } from './static/itim/itim.component';
import { ItimBookComponent } from './static/itim-book/itim-book.component';
import { OperationsManualComponent } from './static/operations-manual/operations-manual.component';
import { StatementOfFaithComponent } from './static/statement-of-faith/statement-of-faith.component';
import { SpanishItimComponent } from './static/spanish-itim/spanish-itim.component';
import { SpanishItimBookComponent } from './static/spanish-itim-book/spanish-itim-book.component';
import { RussianItimComponent } from './static/russian-itim/russian-itim.component';
import { RussianItimBookComponent } from './static/russian-itim-book/russian-itim-book.component';
import { TrainingSeminarIntroductoryComponent } from './static/training-seminar-introductory/training-seminar-introductory.component';
import { NewSeminarComponent } from './static/new-seminar/new-seminar.component';
import { LearningFounderComponent } from './static/learning-founder/learning-founder.component';
import { IntroductionComponent } from './static/introduction/introduction.component';
import { CertificatesComponent } from './static/certificates/certificates.component';
import { SeminarLoginComponent } from './static/seminar-login/seminar-login.component';
import { DonatePageComponent } from './donate-page/donate-page.component';

@NgModule({
  declarations: [
    StaticMainComponent,
    DiscipleshipTumiComponent,
    KingsoopersComponent,
    ContactComponent,
    IndexComponent, 
    StaticHeaderComponent, 
    StaticFooterComponent,
    AboutComponent,
    DiscipleshipComponent,
    GetInvolvedComponent,
    GiveComponent,
    SermonsComponent,
    EventComponent,
    ViewYoutubeComponent,
    SafePipe,
    ItimComponent,
    ItimBookComponent,
    OperationsManualComponent,
    StatementOfFaithComponent,
    SpanishItimComponent,
    SpanishItimBookComponent,
    RussianItimComponent,
    RussianItimBookComponent,
    TrainingSeminarIntroductoryComponent,
    NewSeminarComponent,
    LearningFounderComponent,
    IntroductionComponent,
    CertificatesComponent,
    SeminarLoginComponent,
    DonatePageComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    NgbModule,
  ],
  
  providers: [AdminService],
})
export class PagesModule { }
